export default __webpack_public_path__ + "static/media/sesonal.b37e1000.jpg";